import styled from 'styled-components';

/**
 * One editable part of a combination strength. Borderless: a row is a single
 * sentence now, and boxing each one made a plain "each tablet contains 3 mg"
 * look like a record of its own.
 */
export const IngredientRowBox = styled.div`
  margin-bottom: ${(props) => props.theme.spacing(1)};
`;

export const IngredientsWrapper = styled.div`
  width: 100%;
`;

/** The add button and the note explaining what a second row means. */
export const AddRowLine = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${(props) => props.theme.spacing(1)};
`;

export const AddRowHint = styled.span`
  color: ${(props) => props.theme.palette.text.secondary};
  font-size: ${(props) => props.theme.typography.caption.fontSize}px;
`;

export const ReadWrapper = styled.div`
  width: 100%;
  margin-bottom: ${(props) => props.theme.spacing(1.25)};
`;

export const SummaryLine = styled.p`
  margin: 0;
  font-size: ${(props) => props.theme.typography.body1.fontSize}px;
  word-break: break-word;
`;

export const CombinedStrengthLine = styled(SummaryLine)`
  margin-top: ${(props) => props.theme.spacing(0.5)};
`;
